<template>
  <div class="comment-form">
    <Title v-if="!parent">Avis et commentaires</Title>
    <form v-on:submit.prevent="" v-if="userIsLogged()">
      <star-rating
        :star-size="33"
        v-model="rating"
        v-if="parent === 0"
      ></star-rating>
      <textarea
        @input="autoHeight"
        v-model="content"
        placeholder="Votre commentaire"
      ></textarea>
      <ui-button :loading="loading" @click="addComment()">Envoyer</ui-button>
    </form>
    <div v-else>
      Vous devez être connecté pour ajouter un commentaire
    </div>
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
import fetchApi from "@/mixins/fetchApi";
import UiButton from "@/components/ui/UiButton.vue";
import Title from "@/components/ui/Title.vue";

export default {
  components: {
    StarRating,
    Title,
    UiButton
  },
  props: {
    recipe: { required: true, type: [Object, Number] },
    parent: { required: false, default: 0 }
  },
  computed: {
    recipeId() {
      return typeof this.recipe === "object" ? this.recipe.id : this.recipe;
    }
  },
  data() {
    return {
      customToolbar: [["bold", "italic", "underline"]],
      rating: null,
      content: null,
      loading: false,
      froala: null
    };
  },
  mounted() {},
  methods: {
    async addComment() {
      if (!this.content) {
        return false;
      }
      this.loading = true;

      await fetchApi.post("comment", {
        content: this.content,
        rating: this.rating,
        post_id: this.recipeId,
        parent: this.parent
      });

      this.resetForm();
      this.$emit("submit");
    },
    resetForm() {
      this.loading = false;
      this.rating = null;
      this.content = null;
    }
  }
};
</script>
<style lang="scss">
.comment-form {
  textarea {
    resize: none;
    box-shadow: $box-shadow;
    background: $white;
    border-radius: $box-radius;
    overflow: hidden;
    margin: 20px 0;
    width: 100%;
    min-height: 100px;
    border: none;
    padding: 10px;
    transition: box-shadow 0.3s;
    &:focus {
      outline: none;
      box-shadow: 0 0 15px rgba($black, 0.3);
    }
  }
}
</style>
